import { basicInitialState } from 'store/_utils/basicInitialState';
import { TFarmLicenceState } from './farmLicenceModel';

export const farmLicenceInitialState: TFarmLicenceState = {
  ...basicInitialState,
  licence: null
};
